<script setup>
    import { defineProps, computed } from 'vue';
    import GradientScoreBar from './GradientScoreBar.vue';
    const props = defineProps({
        items: {
            type: Array,
            required: true
        },
        industryName: {
            type: String,
            required: true
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    })
   
    const displayedItems = computed(() => {
        return props.items.slice(0, 4).map(item => ({
            ...item,
            value: item.value / 100
        }));
    })
</script>

<template>
    <div class="card-container flex flex-col gap-6 p-5 rounded-xl w-full items-center justify-center min-h-[200px]">
        <div v-if="isLoading" class="h-full w-full flex justify-center items-center">
            <div class="animate-spin rounded-full h-12 w-12 border-4 border-echoes-border-gray border-t-echoes-primary"></div>
        </div>
        <template v-else>
            <div class="flex w-full">
                <v-tooltip
                    activator="parent"
                    location="top"
                >
                    {{ props.industryName }}
                </v-tooltip>
                <div class="title">{{ props.industryName }}</div>
            </div>
            <div class="flex gap-4 px-4 justify-center w-full overflow-hidden min-w-0">
                <GradientScoreBar 
                    v-for="(item, index) in displayedItems" 
                    :key="index"
                    :value="item.value"
                    orientation="vertical"
                    rounded-size="rounded-md"
                    :label="item.label"
                    text-size="text-xs"
                    thickness="w-7"
                    label-font-weight="font-normal"
                    :animated="true"
                    class="flex-shrink-0 min-w-0"
                />
            </div>
        </template>
    </div>
</template>

<style scoped lang="postcss">

.card-container {
    position: relative;
    
    border: 1px solid #0F0F0F;
    border-radius: 1rem;
}



.card-container > * {
    position: relative;
    z-index: 1;
}

.title {
    @apply text-base font-semibold bg-gradient-to-br from-white to-white/30 bg-clip-text text-transparent inline-block;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

</style>